import { render, staticRenderFns } from "./ReceiveDispatch.vue?vue&type=template&id=78f1896c&scoped=true"
import script from "./ReceiveDispatch.vue?vue&type=script&lang=js"
export * from "./ReceiveDispatch.vue?vue&type=script&lang=js"
import style0 from "./ReceiveDispatch.vue?vue&type=style&index=0&id=78f1896c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f1896c",
  null
  
)

export default component.exports